import classNames from "classnames";
import "./OpticksTitleViewSection.css";
import OpticksExpanded from "../OpticksExpanded/OpticksExpanded";
import { useState } from "react";
import OpticksButton from "../OpticksButton/OpticksButton";
import OpticksExpanderChevronIcon from "../OpticksIconsComponents/OpticksExpanderChevronIcon/OpticksExpanderChevronIcon";

interface Props {
  type: "view" | "section" | "subsection";
  title: string | React.ReactNode;
  subtitle?: string | React.ReactNode;
  icon?: React.ReactNode;
  rightAction?: React.ReactNode;
  label?: React.ReactNode;
  disabled?: boolean;
  about?: { title: string; content: React.ReactNode };
  moreActions?: {
    title: string;
    link: (() => void) | null;
    icon: React.ReactNode;
    iconTrailing?: React.ReactNode;
  }[];
}

const OpticksTitleViewSection = ({
  title,
  subtitle,
  type,
  icon,
  rightAction,
  label,
  disabled = false,
  about,
  moreActions,
}: Props) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div
      className={classNames("opticks-title", `type-${type}`, {
        disabled: disabled,
      })}
    >
      <div className="opticks-title-main">
        <div className="opticks-title__start">
          <div className="opticks-title__start-wrapper">
            <div className="opticks-title-icon-title">
              {icon && <div className="opticks-title__icon">{icon}</div>}
              {type === "view" && <h1>{title}</h1>}
              {type === "section" && <h3>{title}</h3>}
              {type === "subsection" && <h4>{title}</h4>}
              {label && <>{label}</>}
            </div>
            {about && (
              <OpticksExpanderChevronIcon
                expanded={isExpanded}
                label="Learn More"
                onClick={() => setIsExpanded(!isExpanded)}
                size="unset"
              />
            )}
          </div>
          {subtitle && <div className="opticks-title-subtitle">{subtitle}</div>}
        </div>
        {rightAction && (
          <div className="opticks-title__end">{rightAction}</div>
        )}
      </div>

      {about && (
        <OpticksExpanded isExpanded={isExpanded}>
          <div className="opticks-title-about">
            <h5>{about.title}</h5>
            {about.content}
          </div>
          {moreActions && (
            <div className="opticks-title-more-actions">
              {moreActions.map((action) => {
                return (
                  <OpticksButton
                    size="s"
                    variation="ghost"
                    key={action.title}
                    label={action.title}
                    icon={action.icon}
                    iconTrailing={action.iconTrailing}
                    onClick={action.link || undefined}
                  />
                );
              })}
            </div>
          )}
        </OpticksExpanded>
      )}
    </div>
  );
};

export default OpticksTitleViewSection;
